import { Hidden } from '@mui/material'
import { GetStaticProps, NextPage } from 'next'
import dynamic from 'next/dynamic'
import { useState } from 'react'
// import { ContentHeader } from 'src/components/ContentHeader/ContentHeader'
// import { ContentPagination } from 'src/components/ContentPagination/ContentPagination'
import { Footer } from 'src/components/Footer/Footer'
// import { Breadcrumb } from 'src/components/global/Breadcrumb'
import MainContainer from 'src/components/global/MainContainer/MainContainer'
// import { PremiumModal } from 'src/components/global/PremiumModal'
// import { SearchField } from 'src/components/global/SearchField'
// import { Sidebar } from 'src/components/global/Sidebar'
import { ThemeOnly } from 'src/components/global/ThemeOnly'
import { ReCaptcha } from 'src/components/ReCaptcha/ReCaptcha'
import { THEME } from 'src/config/config'
// import { useAuthenticated } from 'src/hooks/useAuthenticated'
import { Meta } from 'src/layout/Meta'
import { Main } from 'src/templates/Main'
import { FilterOption } from 'src/types'
import {
  getAudiencesFilter,
  getAuthorsFilter,
  getContentTypesFilter,
  getDateFilter,
  getDocumentTypesFilter,
  getPhasesFilter,
  getProductTypesFilter,
  getSubjectsFilter,
} from 'src/utils/ContentFilters/contentFilters'

type Props = {
  filters: FilterOption[]
}

const PremiumModal = dynamic(() => import('src/components/global/PremiumModal').then((mod) => mod.PremiumModal), {
  loading: () => <p className="loading-placeholder"></p>,
  ssr: false,
})
const Breadcrumb = dynamic(() => import('src/components/global/Breadcrumb').then((mod) => mod.Breadcrumb), {
  loading: () => <p className="loading-placeholder"></p>,
  ssr: false,
})
const ContentHeader = dynamic(
  () => import('src/components/ContentHeader/ContentHeader').then((mod) => mod.ContentHeader),
  {
    loading: () => <p className="loading-placeholder"></p>,
    ssr: false,
  },
)

const Sidebar = dynamic(() => import('src/components/global/Sidebar').then((mod) => mod.Sidebar), {
  loading: () => <p className="loading-placeholder"></p>,
  ssr: false,
})
const SearchField = dynamic(() => import('src/components/global/SearchField').then((mod) => mod.SearchField), {
  loading: () => <p className="loading-placeholder"></p>,
  ssr: false,
})

const ContentPagination = dynamic(
  () => import('src/components/ContentPagination/ContentPagination').then((mod) => mod.ContentPagination),
  {
    loading: () => <p className="loading-placeholder"></p>,
    ssr: false,
  },
)

const Contents: NextPage<Props> = ({ filters }: Props) => {
  const [showModal, setShowModal] = useState(false)
  // const { isPremium } = useAuthenticated()
  // const filtersDisabled = useMemo(() => !isPremium, [isPremium])
  const title = 'Contents'
  const description =
    'Know how about digital transformation, knowledge management and innovation in law firms and in-house legal departments.'

  const meta = <Meta title={title} description={description} url="/industry-analysis/" />
  return (
    <ReCaptcha>
      <Main meta={meta}>
        {showModal && <PremiumModal origin="/contents/" isOpen={showModal} onClose={() => setShowModal(false)} />}

        <MainContainer id="mainContainer">
          <div className="flex flex-col bg-clouds pb-12">
            <Breadcrumb subject="Contents" />
            <ContentHeader />
          </div>
          <hr />
          <div className="flex flex-row justify-center w-full md:pl-0 md:pr-0 pl-[20px] pr-[20px]">
            <div className="!max-w-[1100px] flex flex-row justify-between w-full mb-32">
              <Hidden mdDown>
                <div className="w-1/4 pr-10 flex flex-col">
                  <SearchField className="my-8" />
                  <Sidebar
                    filterOptions={filters}
                    // filtersDisabled={filtersDisabled}
                    defaultSelectFilterIdx={1}
                    onClickWhenDisabled={() => setShowModal(true)}
                  />
                </div>
              </Hidden>
              <ContentPagination
                filterProps={filters}
                // filtersDisabled={filtersDisabled}
                onClickWhenDisabled={() => setShowModal(true)}
              />
            </div>
          </div>

          <ThemeOnly theme="legaltech">
            <Footer />
          </ThemeOnly>
        </MainContainer>
      </Main>
    </ReCaptcha>
  )
}

export default Contents

export const getStaticProps: GetStaticProps<Props> = async ({}) => {
  if (THEME === 'ilta') return { revalidate: 60, notFound: true }
  try {
    const filters: FilterOption[] = await Promise.all([
      getAudiencesFilter(),
      getSubjectsFilter({ includeSubjectMatters: true, includeThemes: true }),
      getContentTypesFilter(),
      getProductTypesFilter(),
      getPhasesFilter(),
      getDocumentTypesFilter(),
      getAuthorsFilter({ includeAuthors: true, includeExperts: true }),
      getDateFilter(),
    ])

    return {
      props: {
        filters,
      },
      revalidate: 60,
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error occurred in getStaticProps of Content:', error)
    // Graceful fallback in case of an upstream error
    return {
      notFound: true,
      revalidate: 60, // Reattempt fetching during the next static regeneration
    }
  }
}
